import { useState, useEffect } from 'react'
import { supabase } from '../../lib/supabase'
import { Sparkles, X } from 'lucide-react'

// Vendor category → budget category (name + icon matching the budget presets)
const MAP = {
  photographer:   { name:'Photography & Video',   icon:'📸' },
  videographer:   { name:'Photography & Video',   icon:'📸' },
  decorator:      { name:'Décor & Flowers',       icon:'💐' },
  mc_dj:          { name:'Music & Entertainment', icon:'🎵' },
  live_band:      { name:'Music & Entertainment', icon:'🎵' },
  caterer:        { name:'Catering & Food',       icon:'🍽️' },
  cake:           { name:'Catering & Food',       icon:'🍽️' },
  aso_ebi:        { name:"Bride's Attire",        icon:'👗' },
  bridal_fashion: { name:"Bride's Attire",        icon:'👗' },
  makeup:         { name:"Bride's Attire",        icon:'👗' },
  venue:          { name:'Venue & Hall',          icon:'🏛️' },
  planner:        { name:'Miscellaneous',         icon:'📦' },
}
const HANDLED_KEY = 'okoiya_aisle_budget_handled'
const getHandled = () => { try { return JSON.parse(localStorage.getItem(HANDLED_KEY) || '[]') } catch { return [] } }
const markHandled = id => { const h = getHandled(); if (!h.includes(id)) localStorage.setItem(HANDLED_KEY, JSON.stringify([...h, id])) }

/**
 * Suggests adding booked Aisle vendors to the matching budget category.
 * Never auto-creates — the couple taps "Add". Dismissals persist per booking.
 */
export default function VendorBudgetSuggestions({ weddingId, onAdded }) {
  const [items, setItems] = useState([])
  const [busyId, setBusyId] = useState(null)

  useEffect(() => {
    if (!weddingId) return
    supabase.rpc('aisle_my_bookings').then(({ data }) => {
      const handled = getHandled()
      setItems((data || []).filter(b => b.starting_price && !handled.includes(b.booking_id)))
    }, () => {})
  }, [weddingId])

  async function add(b) {
    setBusyId(b.booking_id)
    try {
      const map = MAP[b.category] || { name:'Miscellaneous', icon:'📦' }
      let { data: cat } = await supabase.from('budget_categories')
        .select('id').eq('wedding_id', weddingId).eq('name', map.name).maybeSingle()
      let catId = cat?.id
      if (!catId) {
        const { data: created } = await supabase.from('budget_categories')
          .insert({ wedding_id: weddingId, name: map.name, icon: map.icon, allocated: 0 }).select('id').single()
        catId = created?.id
      }
      if (catId) {
        await supabase.from('budget_items').insert({
          category_id: catId, description: `${b.business_name} (Okoiya Aisle)`, amount: b.starting_price, paid: false,
        })
      }
    } catch { /* swallow — handled below */ }
    markHandled(b.booking_id)
    setItems(prev => prev.filter(x => x.booking_id !== b.booking_id))
    setBusyId(null)
    onAdded?.()
  }
  function dismiss(b) {
    markHandled(b.booking_id)
    setItems(prev => prev.filter(x => x.booking_id !== b.booking_id))
  }

  if (items.length === 0) return null

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'0.5rem', marginBottom:'1.25rem' }}>
      {items.map(b => {
        const map = MAP[b.category] || { name:'Miscellaneous' }
        return (
          <div key={b.booking_id} style={{ display:'flex', alignItems:'center', gap:'0.75rem',
            background:'rgba(196,130,106,0.07)', border:'1px solid rgba(196,130,106,0.25)', borderRadius:'0.875rem', padding:'0.7rem 0.9rem' }}>
            <Sparkles size={16} color="#C4826A" style={{ flexShrink:0 }} />
            <p style={{ flex:1, minWidth:0, fontFamily:'Nunito Sans, sans-serif', fontSize:'0.8rem', color:'#1A1A1A', margin:0, lineHeight:1.4 }}>
              Add <strong>{b.business_name}</strong> (₦{Number(b.starting_price).toLocaleString()}) to your <strong>{map.name}</strong> budget?
            </p>
            <button onClick={() => add(b)} disabled={busyId === b.booking_id}
              style={{ fontFamily:'Nunito Sans, sans-serif', fontWeight:700, fontSize:'0.74rem', color:'#fff', background:'#C4826A', border:'none', borderRadius:100, padding:'0.4rem 0.9rem', cursor:'pointer', flexShrink:0 }}>
              {busyId === b.booking_id ? '…' : 'Add'}
            </button>
            <button onClick={() => dismiss(b)} title="Dismiss" style={{ background:'none', border:'none', cursor:'pointer', color:'#BCBCBC', flexShrink:0, padding:2 }}>
              <X size={15} />
            </button>
          </div>
        )
      })}
    </div>
  )
}
